/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import Header from '../../../components/Header'
import Footer from '../../../components/footer'

import './User.scss'

import { useNavigate } from 'react-router-dom'

import { get, post } from '../../../services/https'

import { notify } from '../../../components/Toast'
import { ToastContainer } from 'react-toastify'

export default function index() {
  const navigate = useNavigate()

  const [user, setUser] = useState([])
  
  useEffect(() => {
    post('/api/front/users/verify', {
      token: localStorage.getItem('token')
      }).then(response => {
        get(`/api/front/users/${response.data.data.userId}`)
          .then(responseUser => {
            console.log(responseUser)
            setUser(responseUser.data.data)
          }).catch(error => {
            notify('error', 'ابتدا ثبت نام / ورود کنید')
            setTimeout(() => {
              navigate('/login')
            }, 3000)
          })
      }).catch(error => {
        notify('error', 'ابتدا ثبت نام / ورود کنید')
        setTimeout(() => {
          navigate('/login')
        }, 3000)
      })
  }, [navigate])

  return (
    <div id='profile'>
      <ToastContainer rtl />
      <Header name={'رستوران کانولی'} />
      <div className='body'>
      </div>
      <div className="scroll">
        <div className='profileTitle'>اطلاعات کاربری شما</div>
        <div className='profileCard'>
          <div className='item'>
            <span>نام و نام خانوادگی : {user ? user.name : '-'}</span>
            <span></span>
          </div>
          <div className='item'>
            <span>شماره موبایل : 0{user ? user.phoneNumber : '-'}</span>
            <span></span>
          </div>
          <div className='item'>
            <span>آدرس ایمیل : {user ? user.email : '-'}</span>
            <span></span>
          </div>
        </div>
      </div>
      <Footer page={'profile'} />
    </div>
  )
}
